// constants
import { ContactUsSubmissionsActionTypes } from './constants';

const INIT_STATE = {
    contactUsSubmissions: [],
    jobTitle: {},
    page: 1,
    limit: 10,
    totalPages: 0,
    totalResults: 0,
    loading: false,
    hasErrors: false,
    submitted: false,
    isDeleted: false,
};

interface ContactUsSubmissionsActionType {
    type:
    | ContactUsSubmissionsActionTypes.API_RESPONSE_SUCCESS
    | ContactUsSubmissionsActionTypes.API_RESPONSE_ERROR
    | ContactUsSubmissionsActionTypes.CONTACT_US_SUBMISSIONS_LIST

    payload: {
        actionType?: string;
        responseData?: any;
        error?: any;
        validationError?: { error: string; key: string; }[];
        hasErrors: boolean,
        submitted: boolean,
        isDeleted: boolean,
    };
}

interface State {
    contactUsSubmissions: any;
    jobTitle: any;
    page: number;
    limit: number;
    totalPages: number;
    totalResults: number;
}

const ContactUsSubmissions = (state: State = INIT_STATE, action: ContactUsSubmissionsActionType): any => {
    switch (action.type) {
        case ContactUsSubmissionsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload?.actionType) {
                case ContactUsSubmissionsActionTypes.CONTACT_US_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        contactUsSubmissions: action.payload?.responseData?.data,
                        page: action.payload?.responseData?.page,
                        limit: action.payload?.responseData?.limit,
                        totalPages: action.payload?.responseData?.totalPages,
                        totalResults: action.payload?.responseData?.totalResults,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }

        case ContactUsSubmissionsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload?.actionType) {
                case ContactUsSubmissionsActionTypes.CONTACT_US_SUBMISSIONS_LIST: {
                    return {
                        ...state,
                        error: action.payload.error,
                        hasErrors: true,
                        loading: true,
                        submitted: false,
                    };
                }

                default:
                    return { ...state };
            }
        default:
            return { ...state };
    }
};

export default ContactUsSubmissions;
